import { WebSocketProvider } from '../context/notifications-web-socket-context';
import { NotificationMessages } from '../notification-messages';
import { ButtonWidget } from './button-widget';
import { DrawerWrapperComponent, useDrawer } from 'components/drawer-wrapper-component/drawer-wrapper-component';
import { REACT_APP_NOTIFICATION_URL } from 'config';
import { useAuth } from 'features/auth/contexts/auth';

const NotificationMessagesWithDrawer = () => {
  const { toggleDrawer } = useDrawer();

  return <NotificationMessages onClose={() => toggleDrawer(undefined)} />;
};
export const NotificationWidget = () => {
  const { auth } = useAuth();

  if (!auth?.token) return null;

  return (
    <WebSocketProvider url={`${REACT_APP_NOTIFICATION_URL}/notification-socket?access_token=${auth?.token}`}>
      <DrawerWrapperComponent wrapper={<NotificationMessagesWithDrawer />} drawerName="NotificationWidget">
        <ButtonWidget />
      </DrawerWrapperComponent>
    </WebSocketProvider>
  );
};
